import Card from 'src/components/card';
import Label from 'src/components/label';
import Text from 'src/components/text';
import { Document } from 'src/types/document';
import CardRow from 'src/components/cardRow';
import Skeleton from 'src/components/skeleton';
import { formatByLabel, getByLabel } from 'src/utils/documentProperties';

type Props = {
  product?: Document;
};

const DetailsCard = ({ product }: Props) => {
  if (!product) {
    return <Skeleton height="270px" />;
  }

  return (
    <Card>
      <CardRow>
        <div>
          <Label>EV Model</Label>
          <Text>{getByLabel(product.details, 'eVModel')}</Text>
        </div>
        <div>
          <Label>Battery Producers</Label>
          <Text>{getByLabel(product.details, 'batteryProducers')}</Text>
        </div>
        <div>
          <Label>Battery Cell Model</Label>
          <Text>{getByLabel(product.details, 'batteryCellModel')}</Text>
        </div>
        <div>
          <Label>Battery Production Date</Label>
          <Text>
            {formatByLabel(product.details, 'batteryProductionDate', {
              dateLabels: ['batteryProductionDate']
            })}
          </Text>
        </div>
      </CardRow>
      <CardRow>
        <div>
          <Label>Battery Packs Global Trade Identification Number</Label>
          <Text>
            {Number(
              getByLabel(
                product.details,
                'batteryPacksGlobalTradeIdentificationNumber'
              )
            )}
          </Text>
        </div>
        <div>
          <Label>Company Full Name</Label>
          <Text>{getByLabel(product.producer, 'companyFullName')}</Text>
        </div>
      </CardRow>
    </Card>
  );
};

export default DetailsCard;
